module.exports = __webpack_public_path__ + "img/magento.94bffc92.png";